import { Strings } from '@app/constants';
import { IEmergencyContactInfoSchema } from '../types';
import { InternalSubCard } from '@app/components/card';
import { relation } from '@app/mock/pesonal-info';

interface Props {
  userData: IEmergencyContactInfoSchema;
}

export const EmergencyContactInfo = ({ userData }: Props) => {
  const emergencyContacts = userData?.emergencyContact ?? [{ name: '', relation: '', phone: '' }];
  const getRelationNameById = (id: any) => {
    const relations = relation.find((relation) => relation.id === id);
    return relations ? relations.name : 'NA';
  };
  const subCards = emergencyContacts.map((contact, index) => ({
    fields: [Strings.field.name, Strings.addEmployee.relation, Strings.addEmployee.phone],
    data: [
      contact.name || 'NA',
      getRelationNameById(contact.relation) || 'NA',
      contact.phone || 'NA',
    ],
  }));

  return (
    <>
      <InternalSubCard
        title={Strings.addEmployee.emergency}
        height={'270px'}
        subCards={subCards}
        iconImg="ic_emergency"
      />
    </>
  );
};
